export const actionMap = {
  CREATE: {
    registro: {
      action: "CREATE",
      page: "lixeira",
      useBin: true,
      useActivitie: true,
      isImport: false,
      isObjDataUpdate: false,
      isObjDataRecover: false,
      // styles
      showDetails: true,
      showRevertBtn: true,
    },
    importacao: {
      action: "DELETE",
      page: "importação",
      useBin: false,
      useActivitie: false,
      isImport: true,
      isObjDataUpdate: false,
      isObjDataRecover: false,
      // styles
      showDetails: false,
      showRevertBtn: true,
    },
    lixeira: {
      action: "DELETE",
      page: "lixeira",
      useBin: false,
      useActivitie: false,
      isImport: false,
      isObjDataUpdate: false,
      isObjDataRecover: true,
      // styles
      showDetails: true,
      showRevertBtn: true,
    }
  },
  UPDATE: {
    registro: {
      action: "UPDATE",
      page: "registro",
      useBin: false,
      useActivitie: false,
      isImport: false,
      isObjDataUpdate: true,
      isObjDataRecover: false,
      // styles
      showDetails: true,
      showRevertBtn: true,
    },
  },
  DELETE: {
    registro: {
      // styles
      showDetails: true,
      showRevertBtn: false,
    },
    lixeira: {
      // styles
      showDetails: true,
      showRevertBtn: false,
    },
  },
  // Adicione mais mapeamentos aqui para outras combinações de 'action' e 'page' conforme necessário.
};

export const getActionText = (text) => {
  const actions = {
    CREATE: "Adição",
    UPDATE: "Edição",
    DELETE: "Remoção",
  };
  return actions[text] || text;
};

export const getDeviceText = (text) => {
  const devices = {
    web: "Computador",
    app: "Aplicativo",
  };
  return devices[text] || "Computador";
};

export const getPageText = (text) => {
  if (!text) return "N/A";
  const pages = {
    records: "Registro",
    registro: "Registro",
    imports: "Importação",
    importação: "Importação",
    import: "Importação",
    trash: "Lixeira",
    lixeira: "Lixeira",
  };

  const key = String(text).toLowerCase();
  return pages[key] || text;
};

export const NAME_FILTERS_LOCAL_STORAGE = {
  DAY: "selectedDay",
  FORM: "selectedForm",
  TYPE: "selectedType",
  PAGE: "selectedPage",
  DEVICE: "selectedDevice",
  NETWORK: "selectedNetwork",
  AUTHOR: "selectedAuthor",
  IDS_AFFECTED: "selectedIdsAffected",
}

export const NAME_QUERY_PARAMS = {
  DAY: "day",
  FORM: "form",
  TYPE: "type",
  PAGE: "page",
  DEVICE: "device",
  NETWORK: "network",
  AUTHOR: "author",
  IDS_AFFECTED: "idsAffected",
}
